import { RadioGroup } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const RadioGroupStyled = styled(RadioGroup)`
  padding-top: 2rem;
  padding-left: 2rem;
`;
